import { Navigate } from "react-router-dom";
import { LOGIN_ROUTE } from "../routes/towerHeadAdmin/towerHeadAdminRoutes";
import authManager from "../utils/towerHeadAdmin/authManager";

const TowerAdminAuth = ({ children }) => {
  if (authManager.hasTowerHeadAdminAccessToken()) {
    return children;
  } else {
    return <Navigate to={LOGIN_ROUTE} replace />;
  }
};

export default TowerAdminAuth;
